var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-gradient-slider"},[_c('div',{staticClass:"-angles"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip.extend",value:({
        title: _vm.curAngle.text,
        placement: 'left',
        delay: 0,
        wrapperClass: '-label -label-color-picker',
      }),expression:"{\n        title: curAngle.text,\n        placement: 'left',\n        delay: 0,\n        wrapperClass: '-label -label-color-picker',\n      }",modifiers:{"extend":true}}],on:{"click":_vm.updateAngle,"mouseenter":function($event){_vm.angleHover = true},"mouseleave":function($event){_vm.angleHover = false}}},[_c('i',{class:'wticon wticon-' + _vm.curAngle.icon})])]),_vm._v(" "),_c('div',{ref:"slider",staticClass:"-slider",style:([_vm.sliderBackground]),on:{"mousedown":function($event){_vm.clickOnSlider($event);
      _vm.mouseDown($event);}}},[_c('div',{ref:"start",staticClass:"-handle -handle-start",class:{
        '-active': _vm.isStartActive,
      },style:({
        left: _vm.start.position - 2 + '%',
        'background-color': _vm.start.color,
      }),on:{"mousedown":function($event){_vm.$emit('update-selected-color', _vm.start.color, 'start');
        _vm.mouseDown($event);}}}),_vm._v(" "),_c('div',{ref:"end",staticClass:"-handle -handle-end",class:{
        '-active': _vm.isEndActive,
      },style:({
        left: _vm.end.position - 2 + '%',
        'background-color': _vm.end.color,
      }),on:{"mousedown":function($event){_vm.$emit('update-selected-color', _vm.end.color, 'end');
        _vm.mouseDown($event);}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }